import { useSpring, animated } from 'react-spring'

import '../../../styles/opportunity.scss'
import { useDimensionsContext } from '../Chart'
import ShortArrow from './ShortArrow'
import CurvedArrows from './CurvedArrows'
import PersonUp from '../../icons/PersonUp'
import PersonDown from '../../icons/PersonDown'

const Opportunity = ({ step, direction, fade }) => {
  let dimensions = useDimensionsContext()
  dimensions.boundedWidth = dimensions.width - dimensions.marginLeft

  const isSmall = dimensions.height < 420
  const isNarrow = dimensions.width < 560

  if (isNarrow) {
    dimensions.boundedWidth = dimensions.width
  }

  //for lines between r2 and r1
  const config1 = {
    to: {
      xCol1: dimensions.boundedWidth / 3 + 120,
      xCol2: 2 * (dimensions.boundedWidth / 3) + 120,
      y: 90
    },
    from: {
      xCol1: 120,
      xCol2: dimensions.boundedWidth / 3 + 120,
      y: dimensions.boundedHeight / 3 + 90
    },
    delay: direction === 'up' ? 0 : 500,
    config: { duration: 750 }
    //reset: true
  }
  const [animLineProps, animateLine] = useSpring(() => config1)
  animateLine(config1)

  //for short arrows
  const config2 = {
    to: {
      // y2: isSmall
      //   ? -(
      //       dimensions.boundedHeight / 3 +
      //       120 -
      //       (2 * (dimensions.boundedHeight / 3) - 10)
      //     )
      //   : dimensions.boundedHeight / 3 +
      //     120 -
      //     (2 * (dimensions.boundedHeight / 3) - 10),
      y2: -50,
      // translate: `translate(-10,  ${
      //   isSmall
      //     ? -(
      //         dimensions.boundedHeight / 3 +
      //         120 -
      //         (2 * (dimensions.boundedHeight / 3) - 10)
      //       )
      //     : dimensions.boundedHeight / 3 +
      //       120 -
      //       (2 * (dimensions.boundedHeight / 3) - 10)
      // })`
      translate: 'translate(-10, -50)'
    },
    from: {
      y2: 0,
      translate: 'translate(-10,0)'
    },
    delay: 2000,
    config: { duration: 750 },
    reset: true
  }
  const [shortArrowProps, animateShortArrow] = useSpring(() => config2)
  animateShortArrow(config2)

  return (
    <>
      <CurvedArrows step={step} direction={direction} dimensions={dimensions} />
      <g transform={`translate(${isNarrow ? -110 : 0}, 0)`}>
        {/* row 1 */}
        <g>
          <ellipse
            className="experienced"
            cx="120"
            cy="90"
            rx="45"
            ry="20"
            opacity=".3"
          ></ellipse>
          <PersonUp
            className="experienced"
            width={'100px'}
            height={isSmall ? '100px' : '125px'}
            x={70}
            y={isSmall ? 20 : 0}
          />
          <g transform={`rotate(${isNarrow ? '-90' : 0})`}>
            <text
              className={`opportunity-text ${isNarrow ? 'isNarrow' : null}`}
              x={-dimensions.marginLeft - (isNarrow ? 30 : 0)}
              y={65}
            >
              Experienced
            </text>
          </g>
        </g>
        {/* r1 col2 */}
        <g>
          <ellipse
            className={`experienced step-${step}-1 fade-up`}
            cx={dimensions.boundedWidth / 3 + 120}
            cy={90}
            rx="45"
            ry="20"
            opacity=".3"
          />
          <PersonUp
            className={`experienced step-${step} fade-up`}
            width={'100px'}
            height={isSmall ? '100px' : '125px'}
            x={dimensions.boundedWidth / 3 + 70}
            y={isSmall ? 20 : 0}
          />
        </g>
        {/* r1 col3 */}
        <g>
          <ellipse
            className={`experienced step-${step}-2 fade-up`}
            cx={2 * (dimensions.boundedWidth / 3) + 120}
            cy={90}
            rx="45"
            ry="20"
            opacity=".3"
          />
          <PersonUp
            className={`experienced step-${step} fade-up`}
            width={'100px'}
            height={isSmall ? '100px' : '125px'}
            x={2 * (dimensions.boundedWidth / 3) + 70}
            y={isSmall ? 20 : 0}
          />
        </g>
        {/* row 2 */}
        <g>
          {/* r2 col1 */}
          <g>
            <ellipse
              className={`entry-level step-${step} darken`}
              cx="120"
              cy={dimensions.boundedHeight / 3 + 90}
              rx="45"
              ry="20"
              opacity=".3"
            />
            {/* draw on with react-spring, fade off with css animations */}
            <animated.line
              className={`line step-${step} ${direction}`}
              x1={120}
              y1={dimensions.boundedHeight / 3 + 90}
              //x2={120}
              x2={animLineProps.xCol1}
              y2={animLineProps.y}
            />

            <PersonUp
              className={`entry-level step-${step} fade-out`}
              width={'100px'}
              height={isSmall ? '100px' : '125px'}
              x={70}
              y={dimensions.boundedHeight / 3 + (isSmall ? 20 : 0)}
            />
            <g
              transform={`translate(${
                isNarrow ? 65 : -dimensions.marginLeft
              }, ${
                dimensions.boundedHeight / 3 + (isNarrow ? 24 : 0) + 70
              }) rotate(${isNarrow ? -90 : 0})`}
            >
              <text
                className={`opportunity-text ${isNarrow ? 'isNarrow' : null}`}
                x={0}
                y={0}
              >
                Entry level
              </text>
            </g>
          </g>
          {/* r2 col2 */}
          <g>
            <ellipse
              className={`entry-level step-${step} darken`}
              cx={dimensions.boundedWidth / 3 + 120}
              cy={dimensions.boundedHeight / 3 + 90}
              rx="45"
              ry="20"
              opacity=".3"
            />
            {/* draw on with react-spring, fade off with css animations */}
            <animated.line
              className={`line step-${step} ${direction}`}
              x1={dimensions.boundedWidth / 3 + 120}
              y1={dimensions.boundedHeight / 3 + 90}
              //x2={dimensions.boundedWidth / 3 + 120}
              x2={animLineProps.xCol2}
              y2={animLineProps.y}
            />
            <PersonUp
              className={`entry-level step-${step} fade-out`}
              width={'100px'}
              height={isSmall ? '100px' : '125px'}
              x={dimensions.boundedWidth / 3 + 70}
              y={dimensions.boundedHeight / 3 + (isSmall ? 20 : 0)}
            />
          </g>
          {/* r2 col3 */}
          <g>
            <ellipse
              className={`entry-level step-${step} darken fade-up`}
              cx={2 * (dimensions.boundedWidth / 3) + 120}
              cy={dimensions.boundedHeight / 3 + 90}
              rx="45"
              ry="20"
              opacity=".3"
            />
          </g>
        </g>

        {/* row 3 */}
        <g>
          {/* r3 col 1 */}
          <g>
            <ellipse
              className="marginalized"
              cx={120}
              cy={2 * (dimensions.boundedHeight / 3) + 100}
              rx="45"
              ry="20"
              opacity=".3"
            />
            <text
              className="marginalized label"
              x={120}
              y={2 * (dimensions.boundedHeight / 3) + 140}
            >
              young
            </text>
            <PersonDown
              className="marginalized"
              width={'100px'}
              height={isSmall ? '100px' : '125px'}
              x={70}
              y={2 * (dimensions.boundedHeight / 3) + (isSmall ? 20 : 0)}
            />
            <g
              transform={`translate(${
                isNarrow ? 65 : -dimensions.marginLeft
              }, ${
                ((isSmall ? 2.35 : 2) * dimensions.boundedHeight) / 3 +
                (isNarrow ? 30 : 0) +
                70
              }) rotate(${isNarrow ? -90 : 0})`}
            >
              <text
                className={`opportunity-text ${isNarrow ? 'isNarrow' : null}`}
                x={0}
                y={0}
              >
                Marginalized
              </text>
            </g>
            {!isNarrow && (
              <text
                className={`opportunity-text`}
                x={-dimensions.marginLeft}
                y={2 * (dimensions.boundedHeight / 3) + (isSmall ? 110 : 90)}
              >
                workers
              </text>
            )}

            <ShortArrow
              transform={`translate(120, ${
                2 * (dimensions.boundedHeight / 3) + (isSmall ? 60 : 0)
              })`}
              step={step}
              direction={direction}
              shortArrowProps={shortArrowProps}
              fade={fade}
            />
            <ShortArrow
              transform={`translate(${120 + dimensions.boundedWidth / 6}, ${
                2 * (dimensions.boundedHeight / 3) + (isSmall ? 60 : 0)
              })`}
              step={step}
              direction={direction}
              shortArrowProps={shortArrowProps}
              fade={fade}
            />
          </g>
          {/* r3 col2 */}
          <g>
            <ellipse
              className="marginalized"
              cx={dimensions.boundedWidth / 3 + 120}
              cy={2 * (dimensions.boundedHeight / 3) + 100}
              rx="45"
              ry="20"
              opacity=".3"
            />
            <text
              className={`marginalized label step-${step}-1 fade-up`}
              x={dimensions.boundedWidth / 3 + 120}
              y={2 * (dimensions.boundedHeight / 3) + 140}
            >
              less skilled
            </text>
            <PersonDown
              className={`marginalized step-${step}-1 fade-up  ${direction}`}
              width={'100px'}
              height={isSmall ? '100px' : '125px'}
              x={dimensions.boundedWidth / 3 + 70}
              y={2 * (dimensions.boundedHeight / 3) + (isSmall ? 20 : 0)}
            />

            <ShortArrow
              transform={`translate(${dimensions.boundedWidth / 3 + 120}, ${
                2 * (dimensions.boundedHeight / 3) + (isSmall ? 60 : 0)
              })`}
              step={step}
              direction={direction}
              shortArrowProps={shortArrowProps}
              fade={fade}
            />
            <ShortArrow
              transform={`translate(${
                120 + (3 * dimensions.boundedWidth) / 6
              }, ${2 * (dimensions.boundedHeight / 3) + (isSmall ? 60 : 0)})`}
              step={step}
              direction={direction}
              shortArrowProps={shortArrowProps}
              fade={fade}
            />
          </g>
          {/* r3 col3 */}
          <g>
            <ellipse
              className="marginalized"
              cx={2 * (dimensions.boundedWidth / 3) + 120}
              cy={2 * (dimensions.boundedHeight / 3) + 100}
              rx="45"
              ry="20"
              opacity=".3"
            />
            <text
              className={`marginalized label step-${step}-2 fade-up ${direction}`}
              x={2 * (dimensions.boundedWidth / 3) + 120}
              y={2 * (dimensions.boundedHeight / 3) + 140}
            >
              unemployed
            </text>
            <PersonDown
              className={`marginalized step-${step}-2 fade-up `}
              width={'100px'}
              height={isSmall ? '100px' : '125px'}
              x={2 * (dimensions.boundedWidth / 3) + 70}
              y={2 * (dimensions.boundedHeight / 3) + (isSmall ? 20 : 0)}
            />

            <ShortArrow
              transform={`translate(${
                2 * (dimensions.boundedWidth / 3) + 120
              }, ${2 * (dimensions.boundedHeight / 3) + (isSmall ? 60 : 0)})`}
              step={step}
              direction={direction}
              shortArrowProps={shortArrowProps}
              fade={fade}
            />
          </g>
        </g>
      </g>
    </>
  )
}

export default Opportunity
